import { api } from '../middleware/api';

export interface TasmacScanLine {
  brandNo: string;
  desc: string;
  sizeMl: number;
  bottles: number;
  mrp: number;
  invoiceUnitPrice: number;
  amount: number;
  suspect: boolean;
  match: 'auto' | 'choose' | 'none';
  productId: number | null;
  productName: string;
  qty: number | null;
  rate: number | null;
  unit: 'ml' | 'btl' | null;
  options: {id: number; name: string; code: string; ml: boolean}[];
}

export interface TasmacScanResult {
  status: 'pending' | 'processing' | 'done';
  invoice?: {no: string | null; date: string | null; total: number | null};
  supplier?: {
    match: 'auto' | 'choose' | 'none';
    id: number | null;
    name: string;
    gstin: string | null;
    options: {id: number; name: string}[];
  };
  charges?: {tcs: number; otherCharges: number; roundOff: number; vat: number; excise: number};
  mlProductIds?: number[];
  lines?: TasmacScanLine[];
  warnings?: string[];
}

export const stepurchaseApi = api
  .enhanceEndpoints({ addTagTypes: ['Purchase'] })
  .injectEndpoints({
    endpoints: builder => ({
      getPurchases: builder.query<st_egate[], string>({
        query: cid => `stepurchase/${cid}`,
        providesTags: ['Purchase']
      }),
      getPurchase: builder.query<st_egate, string>({
        query: id => `stepurchase/byid/${id}`
      }),
      // Upload a TASMAC invoice photo; returns the OCR job id to poll with getTasmacScan.
      scanTasmacInvoice: builder.mutation<{jobId: string}, FormData>({
        query: form => ({
          url: `stepurchase/scan-tasmac`,
          method: 'POST',
          body: form
        })
      }),
      getTasmacScan: builder.query<TasmacScanResult, string>({
        query: jobId => `stepurchase/scan-tasmac/${jobId}`,
        keepUnusedDataFor: 0
      }),
      insertPurchase: builder.mutation({
        query: gate => ({
          url: `stepurchase/`,
          method: 'POST',
          body: gate
        }),
        invalidatesTags: ['Purchase']
      }),
      updatePurchase: builder.mutation({
        query: gate => ({
          url: `stepurchase/`,
          method: 'PUT',
          body: gate
        }),
        invalidatesTags: ['Purchase']
      }),
      deletePurchase: builder.mutation({
        query: purchase => ({
          url: `stepurchase/${purchase.pu_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Purchase']
      })
    })
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPurchasesQuery,
  useGetPurchaseQuery,
  useInsertPurchaseMutation,
  useUpdatePurchaseMutation,
  useDeletePurchaseMutation,
  useScanTasmacInvoiceMutation,
  useLazyGetTasmacScanQuery
} = stepurchaseApi;

